<a *ngIf="imgUrl" loading="lazy" [style.background-image]="imgUrl" class="panel nav-panel courseware-panel mylazy"
    [routerLink]="[area, topic.TopicInformation.Alias]">
    <div class="panel-text-wrap">
        <h2>{{topic.TopicInformation.Title}}</h2>
    </div>
    <div class="nav-panel-bkgd"></div>
</a>